import TopBar from '../components/molecules/TopBar';
import TopBarHomeButton from '../components/atoms/TopBarHomeButton';
import { useAppSelector } from 'src/store/hooks';
import MarkdownRenderer from 'src/components/molecules/MarkdownRenderer';


const StudyInfo = () => {
    const config = useAppSelector(state => state.globalState.config);

    return (
        <div className="content">
            <TopBar
                leftButtons={[<TopBarHomeButton />]}
                title={config?.homeMenuItems['study_info']?.customMenuLabel || "Infos zur Studie"}
                icon="icon_info.svg"
            />
            <div className="info-page">
                {config?.studyInfoContent && (
                    <MarkdownRenderer content={config.studyInfoContent} />
                )}
            </div>
        </div>
    );
};
export default StudyInfo;